module.exports = __webpack_public_path__ + "img/img5_6.5eeb92df.jpeg";